import { useMemo } from 'react'
import type { Option } from './PollCard'

export function usePollMetrics(options: Option[]) {
	return useMemo(() => {
		const totals = options.reduce(
			(acc, option) => {
				acc.totalTokensUsed += option.tokens ?? 0n
				acc.totalVotes += option.votes ?? 0n

				return acc
			},
			{ totalTokensUsed: BigInt(0), totalVotes: BigInt(0) }
		)

		return {
			totalTokensUsed: totals.totalTokensUsed,
			hasLockedTokens: totals.totalTokensUsed > 0n,
			totalVotes: totals.totalVotes,
			hasVotes: totals.totalVotes > 0n
		} as const
	}, [options])
}
